import Setting from "@/types/Setting";

interface HasSetting {
  settings: Setting[];
}

export function useSettings() {
  function match(entity: HasSetting, tag: string): boolean {
    if (!entity.settings) return true;

    const candidate = entity.settings.find(s => s.tag === tag);

    if (candidate === undefined) return true;

    return candidate.value;
  }

  return {
    match,
  };
}
